export const PROJECT_STATUSES = [
  'Pending',
  'In Progress',
  'On Hold',
  'Completed',
  'Cancelled',
];

export const ONGOING_STATUSES = ['Pending', 'In Progress', 'On Hold'];

export const EXPENSE_STATUSES = ['Paid', 'Unpaid'];

/** Delay before an employee expense appears in the admin feed */
export const EXPENSE_ADMIN_SEND_DELAY_MS = 20000;

export const PROJECT_SERVICES = [
  'Pre-Production',
  'Production',
  'Post-Production',
  'Editing',
  'Photography',
  'Videography',
  'Animation',
  'Motion Graphics',
  'Color Grading',
  'Sound Design',
];

export const ADMIN_TABS = ['projects', 'expenses', 'profit-loss', 'financial-analytics', 'invoices'];

export const STATUS_COLORS = {
  Pending: 'warning',
  'In Progress': 'info',
  'On Hold': 'secondary',
  Completed: 'success',
  Cancelled: 'danger',
  Paid: 'success',
  Unpaid: 'warning',
};

export const DEFAULT_SETTINGS = {
  companyGstin: '',
  companyState: 'Karnataka',
  companyAddress: 'Bangalore, Karnataka',
  gstRate: 18,
};

export const ITEMS_PER_PAGE = 10;
